import { useState } from 'react';

import Link from 'next/link';
import { IconType } from 'react-icons';
import { AiOutlineMore, AiOutlineRise } from 'react-icons/ai';
import { BsQuestionCircle } from 'react-icons/bs';
import { CgBolt } from 'react-icons/cg';
import { HiChevronDown, HiPhone } from 'react-icons/hi';
import {
  IoBriefcaseOutline,
  IoCarSportOutline,
  IoDiamond,
  IoFootballOutline,
  IoHomeOutline,
  IoPhonePortraitOutline,
  IoShirtOutline,
} from 'react-icons/io5';
import { MdOutlineBeachAccess, MdOutlineRealEstateAgent } from 'react-icons/md';
import { RiBuilding2Line } from 'react-icons/ri';
import { useWindowSize } from 'usehooks-ts';

import { TkArrowUp, TkCard } from '@/tayara-kit/icons';
import Text from '@/tayara-kit/Text';
import Tooltip from '@/tayara-kit/Tooltip';

export const ThirdSectionContent = () => {
  const windowSize = useWindowSize();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };
  const adsPricing = [
    {
      Véhicules: {
        simpleBoostTokenPrice: '70',
        simpleBoostDinarsPrice: '7',
        boosttwentyFourTokenPrice: '360',
        boosttwentyFourDinarsPrice: '36',
        boostSevenTokenPrice: '330',
        boostSevenDinarsPrice: '33',
        boostALaUneTokenPrice: '500',
        boostALaUneDinarsPrice: '50',
      },
      'Pour la Maison et Jardin': {
        simpleBoostTokenPrice: '34',
        simpleBoostDinarsPrice: '3.4',
        boosttwentyFourTokenPrice: '200',
        boosttwentyFourDinarsPrice: '20',
        boostSevenTokenPrice: '200',
        boostSevenDinarsPrice: '20',
        boostALaUneTokenPrice: '300',
        boostALaUneDinarsPrice: '30',
      },
      'Emploi et Services': {
        simpleBoostTokenPrice: '34',
        simpleBoostDinarsPrice: '3.4',
        boosttwentyFourTokenPrice: '200',
        boosttwentyFourDinarsPrice: '20',
        boostSevenTokenPrice: '200',
        boostSevenDinarsPrice: '20',
        boostALaUneTokenPrice: '500',
        boostALaUneDinarsPrice: '50',
      },
      Immobilier: {
        simpleBoostTokenPrice: '50',
        simpleBoostDinarsPrice: '5',
        boosttwentyFourTokenPrice: '260',
        boosttwentyFourDinarsPrice: '26',
        boostSevenTokenPrice: '260',
        boostSevenDinarsPrice: '26',
        boostALaUneTokenPrice: '400',
        boostALaUneDinarsPrice: '40',
      },
      Entreprises: {
        simpleBoostTokenPrice: '34',
        simpleBoostDinarsPrice: '3.4',
        boosttwentyFourTokenPrice: '250',
        boosttwentyFourDinarsPrice: '25',
        boostSevenTokenPrice: '235',
        boostSevenDinarsPrice: '23.5',
        boostALaUneTokenPrice: '500',
        boostALaUneDinarsPrice: '50',
      },
      'Habillement et Bien Etre': {
        simpleBoostTokenPrice: '34',
        simpleBoostDinarsPrice: '3.4',
        boosttwentyFourTokenPrice: '200',
        boosttwentyFourDinarsPrice: '20',
        boostSevenTokenPrice: '200',
        boostSevenDinarsPrice: '20',
        boostALaUneTokenPrice: '300',
        boostALaUneDinarsPrice: '30',
      },
      'Informatique et Multimédias': {
        simpleBoostTokenPrice: '34',
        simpleBoostDinarsPrice: '3.4',
        boosttwentyFourTokenPrice: '200',
        boosttwentyFourDinarsPrice: '20',
        boostSevenTokenPrice: '200',
        boostSevenDinarsPrice: '20',
        boostALaUneTokenPrice: '300',
        boostALaUneDinarsPrice: '30',
      },
      'Loisirs et Divertissements': {
        simpleBoostTokenPrice: '34',
        simpleBoostDinarsPrice: '3.4',
        boosttwentyFourTokenPrice: '200',
        boosttwentyFourDinarsPrice: '20',
        boostSevenTokenPrice: '200',
        boostSevenDinarsPrice: '20',
        boostALaUneTokenPrice: '300',
        boostALaUneDinarsPrice: '30',
      },
      Autres: {
        simpleBoostTokenPrice: '60',
        simpleBoostDinarsPrice: '6',
        boostSevenTokenPrice: '360',
        boostSevenDinarsPrice: '36',
        boosttwentyFourTokenPrice: '330',
        boosttwentyFourDinarsPrice: '33',
        boostALaUneTokenPrice: '500',
        boostALaUneDinarsPrice: '50',
      },
    },
  ];

  const categoryIcons: { [key: string]: IconType } = {
    Véhicules: IoCarSportOutline,
    'Pour la Maison et Jardin': IoHomeOutline,
    'Emploi et Services': IoBriefcaseOutline,
    Immobilier: MdOutlineRealEstateAgent,
    Entreprises: RiBuilding2Line,
    'Habillement et Bien Etre': IoShirtOutline,
    'Informatique et Multimédias': IoPhonePortraitOutline,
    'Loisirs et Divertissements': IoFootballOutline,
    Vacances: MdOutlineBeachAccess,
    Autres: AiOutlineMore,
  };

  const boostOfferCardContent = [
    {
      coverImage: '/media/ClassicBoostImage.png',
      coverImageAlt: 'Classic Boost tayara',
      icon: CgBolt,
      title: 'Boost classique',
      description:
        'Votre annonce sera poussée en haut de la page: Boost simple, Boost 24 ou Boost 7',
      priceText: 'Voir les prix en détail ci-dessous',
      categoryText: 'Disponible pour toutes les catégories',
      label: 'Contactez-nous',
      labelLink: '/contact',
    },
    {
      coverImage: '/media/ALaUneBoostImage.png',
      coverImageAlt: 'Boost à la une tayara',
      icon: CgBolt,
      title: 'Boost à la une',
      description:
        'Votre annonce sera mise en vedette dans sa catégorie pendant une semaine sur la première ligne',
      priceText: 'Voir les prix en détail ci-dessous',
      categoryText: 'Disponible pour toutes les catégories',
      label: 'Contactez-nous',
      labelLink: '/contact',
    },
    {
      coverImage: '/media/GoldenAdBoostImage.png',
      coverImageAlt: 'Boost Golden Ad tayara',
      icon: CgBolt,
      title: 'Boost Golden Ad',
      description:
        'Votre annonce sera placée en haut des pages de votre catégorie pendant une semaine',
      priceText: 'Voir les prix en détail ci-dessous',
      categoryText: 'Disponible pour toutes les catégories',
      label: 'Contactez-nous',
      labelLink: '/contact',
    },
    {
      coverImage: '/media/ShopOfMonthBoostImage.png',
      coverImageAlt: 'Boost Shop of month tayara',
      icon: CgBolt,
      title: 'Boutique de la semaine',
      description:
        'Votre boutique et vos annonces seront mises en avant sur la page d`accueil pendant une semaine en exclusivité',
      priceText: 'A la demande',
      categoryText: 'Disponible pour toutes les catégories',
      label: 'Contactez-nous',
      labelLink: '/leads/tayara-pro',
    },
    {
      coverImage: '/media/RecommendedShopBoostImage.png',
      coverImageAlt: 'Boost Recommended Shop tayara',
      icon: CgBolt,
      title: 'Boutique recommandée',
      description:
        'Le logo de votre boutique sera mis en avant dans la catégorie qui correspond à votre secteur dactivité avec un lien de redirection vers votre shop',
      priceText: 'A la demande',
      categoryText: 'Disponible pour toutes les catégories',
      label: 'Contactez-nous',
      labelLink: '/leads/tayara-pro',
    },
  ];

  return (
    <>
      <div className="flex flex-col mx-auto justify-center items-center w-full md:w-4/6 h-fit mt-16 mb-4 ">
        <Text
          text="Boostez vos annonces efficacement"
          as="h3"
          className="text-2xl md:text-3xl font-bold text-center text-orange-400"
        />
        <div className="flex flex-col">
          <p
            className={`text-sm md:text-lg text-center text-neutral-700 mt-7  ${
              !isExpanded && windowSize.width < 925
                ? 'whitespace-pre-line line-clamp-2'
                : ''
            }`}
          >
            Que vous soyez un vendeur ou un particulier le boost et la meilleure
            solution pour vendre plus vite.
            <br /> Touchez 5 fois plus de visiteurs en atteignant le bon public.
          </p>

          {/* Show more button */}
          {windowSize.width < 925 && (
            <button
              className="text-xs flex justify-center items-center gap-x-1 text-primary font-medium mt-2"
              onClick={() => toggleExpanded()}
            >
              <Text
                as="span"
                text={`${!isExpanded ? 'Lire plus' : 'Moins'}`}
                className="truncate"
              />
              <HiChevronDown
                size={18}
                className={`${isExpanded ? 'rotate-180' : ''}`}
              />
            </button>
          )}
        </div>
        <div className="flex w-full justify-center md:justify-center lg:justify-center items-center mt-7">
          <Link
            href={{ pathname: '/profile', query: { t: 'myListings' } }}
            className=""
            passHref
          >
            <button className="w-full md:w-fit lg:w-fit mx-auto flex flex-col items-center justify-center  rounded-xl border-[1.5px] border-yellow-300 bg-gradient-to-tr from-yellow-300 via-orange-400 to-orange-300 text-white text-base font-extrabold hover:from-yellow-500 hover:to-orange-500 group shadow-sm  hover:shadow-none">
              <div className=" flex mx-5 md:mx-32 lg:mx-28 xl:mx-20 gap-x-5 md:gap-x-6 lg:gap-x-2 items-center">
                <AiOutlineRise
                  className="group-hover:animate-rocking mt-1"
                  size={38}
                />
                <div className="w-full mx-auto flex flex-col my-3 pr-4 md:pr-0">
                  <span className="text-base font-semibold leading-6">
                    Boostez mes annonces
                  </span>
                  <span className="tracking-widest uppercase text-xs font-normal leading-4 ">{`" Bi3 Fissa3 "`}</span>
                </div>
              </div>
            </button>
          </Link>
        </div>
        <Text
          text="Donnez un nouvel élan à vos annonces dès aujourd'hui!"
          as="p"
          className="text-lg lg:text-xl xl:text-3xl font-light italic text-center text-neutral-700 my-12"
        />
      </div>

      <div className="flex items-center justify-center bg-white/40 rounded-3xl md:outline md:outline-[1px] md:outline-dashed md:outline-orange-300/50 px-4 md:p-10 lg:mx-8 mx-0 ">
        <div className="block overflow-x-auto 2xl:overflow-hidden 2xl:flex">
          <div className="inline-block min-w-full align-middle py-4 md:p-6 ">
            <div className="flex justify-center items-center gap-4">
              {boostOfferCardContent.map((boostOfferContent) => {
                // Popover description on small devices
                const DescriptionPopoverInfo = () => (
                  <div className=" w-[15rem] p-3 relative ">
                    <p className="text-xs text-neutral-700 leading-tight">
                      {boostOfferContent.description}
                    </p>
                  </div>
                );
                return (
                  <div
                    key={''}
                    className="flex flex-col justify-center gap-y-4 xl:gap-y-0 xl:justify-between items-center w-[16rem]  h-[30rem] xl:h-[40rem] md:h-[40rem] flex-1  p-4 rounded-2xl border-[1px] border-neutral-300 bg-white/80 border-t-8 border-t-yellow-600/60 bg-from-yellow-[#EED08E]/50 bg-gradient-to-b from-white via-[#EED08E]/50 to-white"
                  >
                    <div className="flex justify-center items-center h-[10rem] w-full truncate">
                      <img
                        src={boostOfferContent.coverImage}
                        alt={boostOfferContent.coverImageAlt}
                        className="my-2"
                      />
                    </div>
                    <div className="flex flex-row-reverse">
                      <div className="ml-2 block lg:group-hover:block xl:hidden">
                        <Tooltip component={<DescriptionPopoverInfo />}>
                          <BsQuestionCircle
                            size={12}
                            className="text-yellow-900"
                          />
                        </Tooltip>
                      </div>
                      <div className="flex ml-6 xl:ml-0 justify-center items-center w-[60px] h-[60px] rounded-full border-[1px] border-yellow-400 text-yellow-900/70">
                        <boostOfferContent.icon size={40} className="" />
                      </div>
                    </div>
                    <Text
                      text={boostOfferContent.title}
                      as="h3"
                      className="text-lg lg:text-lg xl:text-lg font-bold text-center text-neutral-700 truncate"
                    />
                    <div className="flex items-center xl:h-[8rem]">
                      <Text
                        text={boostOfferContent.description}
                        as="p"
                        className="hidden xl:block text-xs md:text-sm font-normal text-center text-neutral-700 my-4"
                      />
                    </div>
                    <Text
                      text={boostOfferContent.priceText}
                      as="h3"
                      className="text-sm font-semibold text-center text-neutral-700 truncate"
                    />
                    <Text
                      text={boostOfferContent.categoryText}
                      as="h3"
                      className="text-xs font-bold  text-center text-neutral-700 truncate"
                    />
                    <Link
                      href={boostOfferContent.labelLink}
                      target="_blank"
                      replace
                      passHref
                      className="mb-4"
                    >
                      <Text
                        text={boostOfferContent.label}
                        as="span"
                        className="text-xs underline font-normal text-center text-neutral-700 truncate"
                      />
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col my-16 gap-y-4">
        <Text
          text="Boostez votre visibilité"
          as="h3"
          className="text-lg lg:text-xl xl:text-xl font-bold text-center text-neutral-700"
        />
        <Text
          text="Choisissez le boost qui vous convient parmi les options suivantes."
          as="p"
          className="text-sm md:text-lg text-center text-neutral-700"
        />
      </div>

      <div className="flex items-center justify-center bg-white/40 rounded-3xl outline outline-[1px] outline-dashed outline-orange-300/50 lg:mx-8 mx-0 md:p-10 p-5">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-4 lg:px-6">
            <div className="relative pb-8 overflow-hidden md:rounded-lg outline outline-[1px] outline-dashed outline-neutral-300">
              <table className="min-w-full table-fixed  ">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="w-[8rem] py-3.5 px-3 text-left text-sm font-semibold text-gray-900 border-r-[1px] border-dashed border-neutral-500/20"
                    ></th>
                    <th
                      scope="col"
                      className="w-[10rem] px-3 py-3.5 text-left text-sm font-semibold text-gray-900 bg-stone-50/40"
                    >
                      <div className="h-[155px] w-[155px] p-3 flex mx-auto items-center justify-center flex-col">
                        <div className="w-full">
                          <TkArrowUp
                            className="mx-auto mb-[-14%] text-gray-600 group-hover:text-blue-500"
                            size="49%"
                          />
                          {/* Cards */}
                          <div className="flex gap-2 text-stone-200">
                            <TkCard className="w-10 h-16" size={'100%'} />
                            <TkCard
                              className="w-10 h-14 mt-[20%]"
                              size={'100%'}
                            />
                            <TkCard className="w-10 h-16" size={'100%'} />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="w-[15rem] px-3 py-3.5 text-left text-sm font-semibold text-gray-900 bg-stone-50/40 border-l-[1px] border-dashed border-neutral-500/20"
                    >
                      <div className="h-[155px] w-[155px] p-3 flex mx-auto items-center justify-center flex-col">
                        <div className="w-full">
                          <IoDiamond
                            className="mx-auto mb-[-15%] text-gray-600 group-hover:text-blue-500"
                            size="49%"
                          />
                          {/* Cards */}
                          <div className="flex gap-2 text-stone-200 ">
                            <TkCard className="w-10 h-16" size={'100%'} />
                            <TkCard
                              className="w-10 h-14 mt-[20%]"
                              size={'100%'}
                            />
                            <TkCard className="w-10 h-16" size={'100%'} />
                          </div>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className=" bg-white ">
                  <tr className="h-full !p-0">
                    <td className="!p-0 w-fit !pr-8 border-r-[1px] border-dashed border-neutral-500/20">
                      <td className="!p-0  flex "></td>
                    </td>
                    <td className="!p-0 w-full h-full flex justify-between items-center bg-stone-50/40">
                      <td className="!p-0 w-[15rem] ">
                        <div className=" rounded-full p-3 flex mx-auto items-center justify-center flex-col">
                          <div className="w-full text-gray-600 group-hover:text-blue-500 flex justify-center">
                            <div className="rounded-full flex justify-center items-center bg-white group-hover:text-blue-500 ">
                              <div className="flex justify-center items-center w-[80px] h-[80px] rounded-full border-[1px] border-gray-600 text-gray-600  ">
                                <CgBolt className="" size={30} />
                              </div>
                            </div>
                          </div>
                          <Text
                            text="Boost Simple"
                            as="h3"
                            className="text-sm lg:text-base font-semibold text-center text-neutral-700 my-4"
                          />
                          <Text
                            text="Votre annonce sera poussée en haut de la page une seule fois"
                            as="p"
                            className="text-xs lg:text-sm text-center text-neutral-700 h-[4rem] flex items-center"
                          />
                        </div>
                      </td>
                      <td className="!p-0 w-[15rem] ">
                        <div className=" rounded-full p-3 flex mx-auto items-center justify-center flex-col">
                          <div className="w-full text-gray-600 group-hover:text-blue-500 flex justify-center">
                            <div className="rounded-full flex justify-center items-center bg-white group-hover:text-blue-500 ">
                              <div className="flex justify-center items-center w-[80px] h-[80px] rounded-full border-[1px] border-gray-600 text-gray-600 ">
                                <CgBolt className="" size={30} />
                                <span className="text-2xl font-black font-sans mr-2 ">
                                  7
                                </span>
                              </div>
                            </div>
                          </div>
                          <Text
                            text="Boost 7"
                            as="h3"
                            className="text-sm lg:text-base font-semibold text-center text-neutral-700 my-4"
                          />
                          <Text
                            text="Votre annonce sera poussée en haut de la page une fois par jour (une fois chaque 24 heures)"
                            as="p"
                            className="text-xs lg:text-sm text-center text-neutral-700 h-[4rem] flex items-center"
                          />
                        </div>
                      </td>
                      <td className="!p-0 w-[15rem] ">
                        <div className=" rounded-full p-3  flex mx-auto items-center justify-center flex-col">
                          <div className="w-full text-gray-600 group-hover:text-blue-500 flex justify-center">
                            <div className="rounded-full flex justify-center items-center bg-white group-hover:text-blue-500 ">
                              <div className="flex justify-center items-center w-[80px] h-[80px] rounded-full border-[1px] border-gray-600 text-gray-600 ">
                                <CgBolt className="" size={30} />
                                <span className="text-2xl font-black font-sans mr-2 ">
                                  24
                                </span>
                              </div>
                            </div>
                          </div>
                          <Text
                            text="Boost 24"
                            as="h3"
                            className="text-sm lg:text-base font-semibold text-center text-neutral-700 my-4"
                          />
                          <Text
                            text="Votre annonce sera poussée en haut de la page 8 fois dans 24h (une fois chaque 3 heures)"
                            as="p"
                            className="text-xs lg:text-sm text-center text-neutral-700 h-[4rem] flex items-center"
                          />
                        </div>
                      </td>
                    </td>
                    <td className="!p-0 w-[15rem] bg-stone-50/40 border-l-[1px] border-dashed border-neutral-500/20">
                      <td className="!p-0 w-[15rem]  ">
                        <div className=" rounded-full p-3  flex mx-auto items-center justify-center flex-col">
                          <div className="w-full text-gray-600 group-hover:text-blue-500 flex justify-center">
                            <div className="rounded-full flex justify-center items-center bg-white group-hover:text-blue-500 ">
                              <div className="flex justify-center items-center w-[80px] h-[80px] rounded-full border-[1px] border-gray-600 text-gray-600 ">
                                <CgBolt className="" size={30} />
                              </div>
                            </div>
                          </div>
                          <Text
                            text="Boost A La Une"
                            as="h3"
                            className="text-sm lg:text-base font-semibold text-center text-neutral-700 my-4"
                          />
                          <Text
                            text="Votre annonce sera mise en vedette pour une semaine"
                            as="p"
                            className="text-xs lg:text-sm text-center text-neutral-700 h-[4rem] flex items-center"
                          />
                        </div>
                      </td>
                    </td>
                  </tr>

                  <tr className="!p-0">
                    <td className="!p-0 !pr-8 border-r-[1px] border-dashed border-neutral-500/20">
                      <td className="!p-0  flex "></td>
                    </td>
                    <td className="w-full flex justify-center items-center !p-0">
                      <td className="!p-0 w-[15rem] ">
                        <div className="flex flex-col justify-center items-center gap-y-2 bg-stone-50/40 py-4">
                          <Text
                            text="Prix"
                            as="span"
                            className="text-sm font-semibold text-center text-neutral-700"
                          />
                          <div className=" w-full flex items-center justify-around">
                            <Text
                              text="(En Jetons)"
                              as="span"
                              className="text-xs  font-normal text-center text-neutral-700"
                            />
                            <Text
                              text="(En Dinars)"
                              as="span"
                              className="text-xs font-normal text-center text-neutral-700"
                            />
                          </div>
                        </div>
                      </td>
                      <td className="!p-0 w-[15rem]">
                        <div className="flex flex-col justify-center items-center gap-y-2 bg-stone-50/40 py-4">
                          <Text
                            text="Prix"
                            as="span"
                            className="text-sm font-semibold text-center text-neutral-700"
                          />
                          <div className=" w-full flex items-center justify-around">
                            <Text
                              text="(En Jetons)"
                              as="span"
                              className="text-xs  font-normal text-center text-neutral-700"
                            />
                            <Text
                              text="(En Dinars)"
                              as="span"
                              className="text-xs font-normal text-center text-neutral-700"
                            />
                          </div>
                        </div>
                      </td>

                      <td className="!p-0 w-[15rem] ">
                        <div className="flex flex-col justify-center items-center gap-y-2 bg-stone-50/40 py-4">
                          <Text
                            text="Prix"
                            as="span"
                            className="text-sm font-semibold text-center text-neutral-700"
                          />
                          <div className=" w-full flex items-center justify-around">
                            <Text
                              text="(En Jetons)"
                              as="span"
                              className="text-xs  font-normal text-center text-neutral-700"
                            />
                            <Text
                              text="(En Dinars)"
                              as="span"
                              className="text-xs font-normal text-center text-neutral-700"
                            />
                          </div>
                        </div>
                      </td>
                    </td>
                    <td className="!p-0 border-l-[1px] border-dashed border-neutral-500/20">
                      <td className="!p-0 w-[15rem] ">
                        <div className="flex flex-col justify-center items-center gap-y-2 bg-stone-50/40 py-4">
                          <Text
                            text="Prix"
                            as="span"
                            className="text-sm font-semibold text-center text-neutral-700"
                          />
                          <div className=" w-full flex items-center justify-around">
                            <Text
                              text="(En Jetons)"
                              as="span"
                              className="text-xs  font-normal text-center text-neutral-700"
                            />
                            <Text
                              text="(En Dinars)"
                              as="span"
                              className="text-xs font-normal text-center text-neutral-700"
                            />
                          </div>
                        </div>
                      </td>
                    </td>
                  </tr>
                  {/* ads pricing */}
                  {adsPricing.map((categoryData, index) =>
                    Object.entries(categoryData).map(
                      ([categoryName, pricing], categoryIndex) => {
                        const Icon = categoryIcons[categoryName];

                        return (
                          <tr
                            key={`${index}-${categoryIndex}`}
                            className="bg-stone-50/40 hover:bg-stone-100 border-b-[1px] border-neutral-500/10"
                          >
                            <td className="!p-0 w-fit !pr-8 !pl-2 border-r-[1px] border-dashed border-neutral-500/20">
                              <td className="!p-0  flex my-4 items-center justify-end gap-x-4">
                                <Text
                                  text={categoryName}
                                  as="span"
                                  className="text-md font-bold text-center text-neutral-700 truncate"
                                />
                                {Icon && (
                                  <Icon
                                    size={windowSize.width < 765 ? 24 : 32}
                                  />
                                )}
                              </td>
                            </td>
                            <td className="!p-0 ">
                              {Object.entries(pricing).map(
                                ([boostType, price], boostIndex) => {
                                  // Exclude boostALaUneTokensPrice and boostALaUneDinarsPrice
                                  if (
                                    boostType !== 'boostALaUneTokenPrice' &&
                                    boostType !== 'boostALaUneDinarsPrice'
                                  ) {
                                    return (
                                      <td
                                        className="w-[15rem]"
                                        key={`${index}-${categoryIndex}-${boostIndex}`}
                                      >
                                        <div className="w-full flex items-center justify-around">
                                          <Text
                                            text={price}
                                            as="span"
                                            className="text-base font-bold text-center text-neutral-700"
                                          />
                                        </div>
                                      </td>
                                    );
                                  }
                                  return null; // Skip rendering for boostALaUneTokensPrice and boostALaUneDinarsPrice
                                }
                              )}
                            </td>

                            <td className="!p-0 border-l-[1px] border-dashed border-neutral-500/20">
                              {Object.entries(pricing).map(
                                ([boostType, price], boostIndex) => {
                                  // Include only boostALaUneTokensPrice and boostALaUneDinarsPrice
                                  if (
                                    boostType === 'boostALaUneTokenPrice' ||
                                    boostType === 'boostALaUneDinarsPrice'
                                  ) {
                                    return (
                                      <td
                                        className="w-[15rem]"
                                        key={`${index}-${categoryIndex}-${boostIndex}`}
                                      >
                                        <div className="w-full flex items-center justify-around">
                                          <Text
                                            text={price}
                                            as="span"
                                            className="text-base font-bold text-center text-neutral-700"
                                          />
                                        </div>
                                      </td>
                                    );
                                  }
                                  return null; // Skip rendering for other pricing options
                                }
                              )}
                            </td>
                          </tr>
                        );
                      }
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center  w-full mx-auto pb-10">
        <Text
          text="Vous avez une question?"
          as="h3"
          className="text-lg font-bold text-center text-neutral-700 mt-12"
        />
        <a
          href={'/contact'}
          target="_blank"
          className=" text-sm lg:text-sm xl:text-base text-center underline text-neutral-700 mt-2 "
        >
          Contactez-nous
        </a>
        <div className="flex text-neutral-700 flex-col items-center ">
          <span className=" flex flex-col items-center text-center">
            <span className="text-sm my-2 font-light italic">Ou</span> Veuillez
            contacter le
            <span className="flex items-center gap-x-1 mt-1 font-bold text-stone-600 ">
              <HiPhone size={16} className="mt-[1px]" />
              +216 95 256 201{' '}
            </span>
          </span>
        </div>
      </div>
    </>
  );
};
